<template lang="html">

  <div class="eventos-view">

    <h2 :style="style.colorBasic">Próximos eventos</h2>

    <section class="listado-eventos container row-start">


      <template v-if="!!data">
        <evento-el v-for="(evento, key) in eventos.slice(0,3)" :key="'evento-'+key" :data="evento"></evento-el>
      </template>

      <div class="contenedor-boton row-center">
        <router-link class="btn -solid-primary" :to="$t('enlaces.eventos')">Ver más</router-link>
      </div>




    </section>


  </div>

</template>

<script lang="js">

  import { mapGetters, mapActions } from 'vuex';

  import encabezado from '@/components/parts/encabezado';

  import evento from '@/components/views/eventos/evento-el'
  import eventoFake from '@/components/views/eventos/evento-el-fake'



  export default {
    name: 'modulo-eventos',
    mounted() {
      this.requestEventos();
    },
    methods: {
      ...mapActions(['requestEventos'])
    },
    computed: {
      ...mapGetters({
        data: 'getEventos',
        colors: 'basicColors',
        style: 'getStyles'
      }),
      eventos() {
        let eventos = new Array();

        if (this.data.length != 0) {
          this.data.forEach(evento => {
            let actual = new Date().getTime();
            let date = new Date(evento.fecha).getTime();
            if (date > actual) {
              eventos.push(evento);
            }
          });

          eventos = eventos.sort((a, b) => {
            let afecha = new Date(a.fecha).getTime();
            let bfecha = new Date(b.fecha).getTime();

            return (afecha - bfecha);

          });
          
          return eventos;

        }
      }
    },
    components: {
      'encabezado': encabezado,
      'evento-el': evento,
      'fake-evento-el': eventoFake
    }
  }
</script>

<style scoped lang="scss">
  h2 {
    font-weight: 800;
    width: 100%;
    font-size: 36px;
    margin-bottom: 50px;
  }

  @media screen and (max-width: 500px) {
    h2 {
      font-size: 24px;
      margin-bottom: 15px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/views/home/modulo-eventos.vue